module.exports = __webpack_public_path__ + "static/media/compress-wide.75cf51d9.svg";